import React from 'react';
import classNameBind from 'classnames/bind';
import Icon from '../../../Icon';
import Label from '../../../Label';
import styles from './MenuElement.module.css';
import Tooltip from '../../../Tooltip';
import Badge from '../../../Badge';

const bindClasses = classNameBind.bind(styles);

const MenuElement = ({
  id,
  name,
  value,
  onClick,
  onBlur,
  selected,
  dataId,
  label,
  tooltip,
  newBadge,
  disabled = false,
  icon = null,
}) => {
  const element = (
    <label
      htmlFor={id}
      data-ppuc-id={`${dataId}.Element`}
      className={bindClasses('element', {
        selected,
        disabled,
      })}
    >
      {icon && (
        <Icon name={icon} />
      )}
      <Label
        disabled={disabled}
        title=""
      >
        {label}
      </Label>
      {newBadge && (
        <Badge
          text="NEW"
          color={selected ? 'blue-inverted' : 'blue'}
          size="small"
          display="inline-block"
        />
      )}
      <input
        className={bindClasses('input')}
        type="radio"
        name={name}
        id={id}
        value={value}
        disabled={disabled}
        data-ppuc-id={`${dataId}.input`}
        onClick={onClick}
        onBlur={onBlur}
      />
    </label>
  );

  return tooltip ? <Tooltip content={tooltip}>{element}</Tooltip> : element;
};

export { MenuElement };
